import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { useState } from "react";
import Checkmark from "../Checkmark.js";

export const ChecklistHeaderSkeleton = () => {
  return (
    <div
      className={`mobile-pref-checklist-header bg-mono-100 dark:bg-mono-950 dark:border-mono-700/50 relative z-0 -mx-2 block space-y-2 px-2 py-4 md:py-8 border-b border-mono-200`}
    >
      <div
        className={`mobile-pref-checklist-header-row flex items-end justify-between gap-x-6 bg-mono-200 dark:bg-mono-800 h-8`}
      >
        <p className={`flex-none leading-5 opacity-60 `}>{""}</p>
      </div>
      <div
        className={`mobile-pref-checklist-progress ${`dark:border-emerald-800 opacity-50 border-emerald-400`} relative h-3 w-full rounded-md border overflow-hidden dark:border-emerald-700/50`}
      >
        <div
          className={`min-w-[30%] absolute h-full transition-colors ${` bg-emerald-200  dark:bg-emerald-600  `}`}
        />
      </div>
    </div>
  );
};

export const ChecklistItemSkeleton = () => {
  return (
    <div
      className={`mobile-pref-card px-4 bg-white shadow dark:bg-mono-950 py-4 border border-mono-200 dark:border-mono-700/50 rounded-md text-mono-800 dark:text-mono-200`}
    >
      <div
        className={`mobile-pref-checklist-row grid gap-x-4 gap-y-6`}
        style={{ gridTemplateColumns: "auto 1fr auto" }}
      >
        <div
          className={`mobile-pref-checklist-status max-w-[100px] min-w-0 -mt-2 flex flex-col items-center`}
        >
          <Checkmark
            className="mobile-pref-checklist-checkmark"
            showCheckmarkHint={false}
            isChecked={false}
            handleChecked={() => null}
          />
          <p
            className={`mobile-pref-card-meta mobile-pref-checklist-count mobile-pref-checklist-count-status opacity-50`}
          >
            {""}
          </p>
        </div>
        <div className={`mobile-pref-checklist-content flex-1`}>
          <div className={`space-y-4 w-full`}>
            <div
              className={`bg-mono-100 dark:bg-mono-900 w-2/3l h-8 flex justify-between`}
            >
              <div>
                <h5 className={`text-base/5 md:text-lg/5 font-medium`}>{""}</h5>
                <p
                  className={`mobile-pref-card-meta mobile-pref-checklist-count mobile-pref-checklist-count-inline opacity-50`}
                >
                  {""}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-pref-checklist-menu">
          <EllipsisVerticalIcon
            className={`mobile-pref-control-icon mobile-pref-checklist-menu-icon size-8 text-mono-200 dark:text-mono-800`}
          />
        </div>
      </div>
    </div>
  );
};

const ChecklistSkeleton = () => {
  // delay the loading of the skeleton
  const [showSkeleton, setShowSkeleton] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSkeleton(true);
    }, 250);
    return () => clearTimeout(timer);
  }, []);
  if (!showSkeleton) return null;

  return (
    <div className={`max-w-4xl mx-auto animate-pulse`}>
      <div className="grid space-y-6 py-2">
        <ChecklistHeaderSkeleton />
        <ChecklistItemSkeleton />
        <ChecklistItemSkeleton />
        <ChecklistItemSkeleton />
      </div>
    </div>
  );
};
export default ChecklistSkeleton;
